import { render, staticRenderFns } from "./SelectContact.vue?vue&type=template&id=44966712&"
import script from "./SelectContact.vue?vue&type=script&lang=js&"
export * from "./SelectContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44966712')) {
      api.createRecord('44966712', component.options)
    } else {
      api.reload('44966712', component.options)
    }
    module.hot.accept("./SelectContact.vue?vue&type=template&id=44966712&", function () {
      api.rerender('44966712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/rentalBookings/widgets/SelectContact.vue"
export default component.exports